import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/** Default screen after sign-in. */
export const DEFAULT_APP_HOME = '/sale';

/**
 * Requires a logged-in session. Use as a parent route `element` with nested `<Route />` children.
 * Unauthenticated users are sent to `/` with `state.from` so they can return after signing in.
 */
export function ProtectedRoute() {
  const { currentUser } = useAuth();
  const location = useLocation();

  if (!currentUser) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return <Outlet />;
}

/**
 * For public-only screens (e.g. login). Authenticated users are redirected to the app home.
 */
export function GuestRoute({ children }) {
  const { currentUser } = useAuth();

  if (currentUser) {
    return <Navigate to={DEFAULT_APP_HOME} replace />;
  }
  return children;
}

